export const POSTHOG_EVENTS = {
  SASS_CLICKED: 'LeadMagnet-Community-PopUp-Clicked-EARLYNODE',
  SASS_OPENED: 'LeadMagnet-Community-PopUp-Opened-EARLYNODE',
  INSIGHTS_OPENED: 'LeadMagnet-Newsletter-PopUp-Opened-EARLYNODE',
  INSIGHTS_SUBSCRIBED: 'LeadMagnet-Newsletter-PopUp-Subscribed-EARLYNODE',
};
